import React from 'react';
import './InfoBadges.css';
import Hexagon from './Hexagon';

const InfoBadges: React.FC = () => {
  return (
    <section className="why-us-container">
      <h2>De ce Neksio Land?</h2>
      <div className="info-badges" id="info-badges-section">
        <div className='hexagon-container'>
          <Hexagon 
            size={130}         // Size of the hexagon side (this controls the overall size)
            borderWidth={10}   // Width of the border effect
            innerColor="white"   // Inner hexagon color
            borderColor="#002f5f"  // Border hexagon color
            src='./truck.svg'
          />
          <h2>Fl<span className='double-underline'>ota noastră</span></h2>
          <p>
          Utilajele noastre sunt întreținute constant, astfel încât să fie mereu gata pentru orice tip de transport. Șoferii Neksio Land sunt șoferi bine pregătiți și înțeleg importanța punctualității și a bunei comunicări cu clientul.
          </p>
        </div>
        
        <div className='hexagon-container'>
          <Hexagon 
            size={130}         // Size of the hexagon side (this controls the overall size)
            borderWidth={10}   // Width of the border effect
            innerColor="white"   // Inner hexagon color
            borderColor="#002f5f"  // Border hexagon color
            src='./corn.svg'
          />
          <h2>Ca<span className='double-underline'>litatea cerealelor noastre</span></h2>
          <p>
          Punem un mare accent pe calitatea cerealelor pe care le vindem. Grâul, porumbul, orzul, rapița, floarea-soarelui și soia cumpărate de la fermieri sunt verificate calitativ în laboratorul de analiză propriu, dotat după ultimele cerințe în domeniu, respectând cele mai înalte standarde de calitate. Colaborăm cu furnizori de încredere și ne asigurăm că fiecare lot de cereale îndeplinește cerințele stricte ale pieței.
          </p>
        </div>
        <div className='hexagon-container'>
          <Hexagon 
            size={130}         // Size of the hexagon side (this controls the overall size)
            borderWidth={10}   // Width of the border effect
            innerColor="white"   // Inner hexagon color
            borderColor="#002f5f"  // Border hexagon color
            src='./clock.svg'
          />
          <h2>Ra<span className='double-underline'>ndament și încredere</span></h2>
          <p>
          La Neksio Land, înțelegem importanța timpului în afaceri. De aceea, ne angajăm să livrăm cerealele tale rapid și eficient, fără întârzieri. Avem o rețea extinsă de clienți în toată țara și suntem mândri de relațiile strânse și de încredere pe care le-am construit de-a lungul anilor.
          </p>
        </div>
    </div>
   </section>
  );
};

export default InfoBadges;
